import axios from 'axios';
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Tab from '../../Components/Tab/Tab';
import Coupon from './Coupon/Coupon';
import Point from './Point/Point';
import './UserInfo.scss';

const routeList = {
    'point': '포인트',
    'coupon' : '쿠폰'
}

const UserInfo = (props) => {
    const { userId } = useParams();//user id param get
    const [ name, setName ] = React.useState('point')//route name
    const [ info, setInfo ] = React.useState({})//user info
    
    const tabRoute = [
        { route : 'point', header : '포인트' },
        { route : 'coupon', header : '쿠폰' },
    ]

    useEffect(() => {
        getInfo()
    },[])

    //유저 정보 Get
    const getInfo = () => {
        axios.get('/api/customer/info/' + userId)
        .then((data) => {
            setInfo(data.data)
        })
    }

    return (
        <div className='wrapper'>
            <div className='header-row'>
                <p className='header-text'>회원정보 {'>'}</p>
                <p className='header'>{routeList[name]}</p>
            </div>
            <Tab
                current={name}
                routes={tabRoute}
                onTabChange={(name) => setName(name)}
                renderItems={{
                    'point' : <Point info={info} getInfo={getInfo}/>,
                    'coupon' : <Coupon info={info} getInfo={getInfo}/>
                }}
            />
        </div>
    )
}

export default UserInfo;